import * as yup from 'yup'

import i18next from '../../../../../i18n.js'

const FINAl_INVOICE_MODEL = {
    date: 'date',
    status: 'status',
    taxable: 'amount',
    note: 'description',
}

const DEFAULT_FINAL_BALANCE_MOCK = {
    [FINAl_INVOICE_MODEL.date]: null,
    [FINAl_INVOICE_MODEL.status]: null,
    [FINAl_INVOICE_MODEL.taxable]: null,
    [FINAl_INVOICE_MODEL.note]: '',
}

const RequestValidationSchema = yup.object().shape({
    [FINAl_INVOICE_MODEL.date]: yup
        .date()
        .required(i18next.t('validation:general_form.date')),
    [FINAl_INVOICE_MODEL.status]: yup
        .object()
        .required(i18next.t('validation:general_form.status')),
    [FINAl_INVOICE_MODEL.taxable]: yup
        .string()
        .required(i18next.t('validation:general_form.taxable')),
    [FINAl_INVOICE_MODEL.note]: yup
        .string()
        .required(i18next.t('validation:general_form.note_required')),
})

export {
    FINAl_INVOICE_MODEL,
    DEFAULT_FINAL_BALANCE_MOCK,
    RequestValidationSchema as validationSchema,
}
